export default "__VITE_ASSET__DKTNCGvs__"